import Tag from '@/shared/models/Tag';
import { mergeInto } from '@/shared/utils';
import { present } from '@/shared/utils/typescript';
import TimeRegistrationClient from '../client/TimeRegistrationClient';
import JobCategory from '../constants/JobCategory';
import Job from '../models/Job';
import JobContext from '../models/JobContext';
import { TimeRegistrationId } from '../models/TimeRegistration';
import TimeRegistrationContainer from '../models/TimeRegistrationContainer';

class TimeRegistrationService {
  async loadAll(context: JobContext): Promise<TimeRegistrationContainer> {
    context.timeRegistrationContainer = await TimeRegistrationClient.loadAll(context.dossier.id);
    context.timeRegistrationContainer.jobs = context.timeRegistrationContainer.jobs
      .filter(j => j.getCategory() === JobCategory.MECHANIC)
      .map(j => context.getJobById(j.id)?.updateWithTimeRegistration(j) ?? j);
    return context.timeRegistrationContainer;
  }

  async create(jobs: Array<Job>, context: JobContext): Promise<void> {
    const container = present(context.timeRegistrationContainer);
    const registration = await TimeRegistrationClient.create(context.dossier.id, jobs);
    jobs.forEach(j => {
      context.getJobById(j.id)?.start();
      context.getSummaryByJobId(j.id)?.start();
    });
    mergeInto(registration, container.registrations);
  }

  async stop(id: TimeRegistrationId, jobs: Array<Job>, context: JobContext, pauseReason: Tag | null = null): Promise<boolean> {
    const container = present(context.timeRegistrationContainer);
    const result = await TimeRegistrationClient.stop(id, jobs.map(j => j.id), pauseReason?.id ?? null, context.dossier.id);
    jobs.forEach(j => {
      context.getJobById(j.id)?.stop(pauseReason);
      context.getSummaryByJobId(j.id)?.stop(pauseReason);
    });
    mergeInto(result.timeRegistration, container.registrations);
    return result.hasAllJobsStopped;
  }
}

export default new TimeRegistrationService();